import Warp from 'warpjs';

// warp-svg
let $warpSvg = $('.warp-svg');
let svg = [];
let animationFrame;

$.each($warpSvg, (index, element) => {
	let id = $(element)[0].id;

	svg[id] = new Warp(document.getElementById(id));
	svg[id].interpolate(15);
	svg[id].transform(([x, y]) => [x, y, y]);
	svg[id].offset = 0;
});

function animateSvg() {
	if (innerWidth < 1025) {
		return;
	}

	let $svgs = $warpSvg.filter('.is-view');

	$.each($svgs, (index, element) => {
		let target = svg[$(element)[0].id];

		// eslint-disable-next-line no-unused-vars
		target.transform(([x, y, oy]) => [x, oy + 5 * Math.sin(x / 100 + target.offset), oy]);
		target.offset += 0.015;
	});

	animationFrame = requestAnimationFrame(animateSvg);
}

function stopSvg() {
	cancelAnimationFrame(animationFrame);
}

let $warpHorizontal = $('.warp-svg-horizontal');
let $warpVertical = $('.warp-svg-vertical');

function lineSvgStart() {
	if (innerWidth < 1025) {
		return;
	}

	if ($('.warp-svg-horizontal, .warp-svg-vertical').hasClass('is-view')) {
		return;
	}

	$('.warp-svg-horizontal, .warp-svg-vertical').addClass('is-view');

	$warpHorizontal.each((i, line) => {
		let warp = new Warp(line);

		warp.interpolate(4);

		let offset = 0;
		function animateLine() {
			warp.transform(([x, y]) => [x, y + 0.2 * Math.sin(x / 7 + offset)]);
			offset += 0.1;
			requestAnimationFrame(animateLine);
		}

		animateLine();
	});

	$warpVertical.each((i, line) => {
		let warp = new Warp(line);

		warp.interpolate(4);

		let offset = 0;
		function animateLine() {
			warp.transform(([x, y]) => [x + 0.2 * Math.sin(y / 7 + offset), y]);
			offset += 0.1;
			requestAnimationFrame(animateLine);
		}

		animateLine();
	});
}

function lineSvgStop() {
	if (innerWidth < 1025) {
		return;
	}

	$warpHorizontal.each((i, line) => {
		let warp = new Warp(line);

		warp.interpolate(4);
		warp.transform(([x, y]) => [x, y]);

		function animateLine() {
			warp.transform(([x, y]) => [x, y]);
			cancelAnimationFrame(animateLine);
		}

		animateLine();
	});

	$warpVertical.each((i, line) => {
		let warp = new Warp(line);

		warp.interpolate(4);
		warp.transform(([x, y]) => [x, y]);
		function animateLine() {
			warp.transform(([x, y]) => [x, y]);
			cancelAnimationFrame(animateLine);
		}

		animateLine();
	});
}

// function updateSvg() {
// 	animateSvg();
// 	stopSvg();
// }

// let svgIsView;

// $(window).on('scroll', () => {
// 	if ($('html').data('page') !== 'article') {
// 		return;
// 	}

// 	let $svgsArr = $('.article:not(.is-hidden)').find('.warp-svg');
// 	let svgIsViewCurr;
// 	let scrollTop = window.pageYOffset;
// 	let scrollTopHeight = scrollTop + window.innerHeight;

// 	$.each($svgsArr, (index, element) => {
// 		let elementTop = $(element).offset().top;
// 		let elementHeight = $(element).height();

// 		if (scrollTopHeight >= elementTop && elementTop + elementHeight >= scrollTop) {
// 			$(element).addClass('is-view');
// 		} else if (elementTop + elementHeight < scrollTop) {
// 			$(element).removeClass('is-view');
// 		}
// 	});

// 	svgIsViewCurr = $svgsArr.filter('is-view');

// 	if (svgIsView !== svgIsViewCurr) {
// 		svgIsView = svgIsViewCurr;
// 		updateSvg();
// 	}
// });

export {
	animateSvg,
	stopSvg,
	lineSvgStart,
	lineSvgStop,
};
